import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HelixExpressMobileApp } from '../../../../shared/constants/mobile-apps';
import { Discount } from '../../../lab-pass/constants/discount.constants';

@Component({
  selector: 'app-catalog-helix-express-ad',
  templateUrl: './helix-express-ad.component.html',
  styleUrls: ['./helix-express-ad.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelixExpressAdComponent {
  readonly Discount = Discount;

  appsLink: Record<string, string> = {
    appleStoreLink: HelixExpressMobileApp.autodetectStoreLinkExpress,
    googlePlayLink: HelixExpressMobileApp.autodetectStoreLinkExpress,
  };
}
